export const training = {
    route: 'Smart Training',
    selectDevice: 'Gerät auswählen',
    saveEvent: 'Ereignis speichern',
    changeEvent: 'Ereignis ändern',
    addNew: 'Neues Gerät ...',
    saveSelected: 'Ausgeählte Ereignisse speichern',
    l1unknown: 'L1 Unbekannt',
    l2unknown: 'L2 Unbekannt',
    l3unknown: 'L3 Unbekannt',
    l123unknown: '3 Phasen Unbekannt',
    l1devices: 'L1 Geräte',
    l2devices: 'L2 Geräte',
    l3devices: 'L3 Geräte',
    l123devices: '3 Phasen Geräte',
    unknownDevice: 'unbekanntes Gerät',
    deleted: 'Löschen',
    filterDevice: 'Filter:',
    unknownDevices: 'Unbekannte Geräte',
    none: 'Keine',
    zoomSelection: 'Zoom Auswahl',
    clearSelection: 'Auswahl/Zoom löschen',
    clearZoom: 'Zoom löschen',
    groupBy: 'Gruppierung nach',
    groupByPhases: 'Phasen',
    groupByDevices: 'Geräte',
    groupBy5Clusters: '5 Cluster',
    groupBy10Clusters: '10 Cluster',
    groupBy20Clusters: '20 Cluster',
    unknown: 'Unbekannt',
    others: 'Andere Geräte',
    cluster: 'Cluster',
    smartTipsTitle: 'Wie funktioniert das Smart Training ?',
    smartTips: [
        { key: 0 , text: 'Hier kannst du alle Verbrauchsereignisse der letzten 30 Tage sehen. Um eine bestimmte Periode auszuwählen benutzte bitte die Schieberegler oberhalb der Grafik.'},
        { key: 1 , text: 'Standardmässig werden die Ereignisse nach Phase gruppiert, aber du kannst andere Optionen wie Gruppierung nach Gerät oder Cluster mit der Auswahlbox rechts oben wählen.'},
        { key: 2 , text: 'Du kannst das touchpad oder Mausrad verwenden um zu zoomen. Zum Zurücksetzten des Zoom-Level kannst du die Schaltfläche oben rechts verwenden.'},
        { key: 3 , text: 'Es gibt zwei Arten von Ereignissen, Ereignisse die schon einem Gerät zugeordnet sind (kleine Kreise) und jene bei denen das Gerät noch unbekannt ist (grosse Kreise).'},
        { key: 4 , text: 'Um unbekannte Ereignisse einem Gerät zuzuordnen, wähle sie durch anclicken aus und drücke dann die  "Ausgeählte Ereignisse speichern" Schaltfläche. Nun kannst du entweder ein neues Gerät anlegen oder die Ereignisse einem bestehden Gerät zuordnen.'}
    ],
    selectPeriod: 'Zeitraum wählen',
    last2min: '2 Minuten',
    last5min: '5 Minuten',
    last10min: '10 Minuten',
    last30min: '30 Minuten',
    last1hour: '1 Stunde',
    last3hours: '3 Stunden',
    last6hours: '6 Stunden',
    last12hours: '12 Stunden',
    last24hours: '24 Stunden',
    today: 'Heute',
    yesterday: 'Gestern',
    thisWeek: 'diese Woche',
    lastWeek: 'letzte Woche',
    thisMonth: 'diesen Monat',
    lastMonth: 'letzten Monat',
    thisQuarter: 'dieses Quartal',
    lastQuarter: 'letztes Quartal',
    thisYear: 'dieses Jahr',
    lastYear: 'letztes Jahr',
    otherPeriod: 'bis zu 1 Jahr',
    durationError: 'Dauer größer als 1 Jahr',
    from: 'Von',
    to: 'Bis',
    powerUsageLabel: 'Stromverbrauch  WATT / VAR',
    recognitionTblNameCol: 'Name',
    recognitionTblCountCol: 'Anzahl',
    recognitionTblWattCol: 'Live Watt',
    recognitionTblWattHoursCol: 'Watt Stunden',
    recognitionTblPercentCol: 'Prozent',
    recognitionTblSelectedCol: 'Auswahl',
    alwaysOnTblDayCol: 'Tag',
    alwaysOnTblP1Col: 'Phase 1',
    alwaysOnTblP2Col: 'Phase 2',
    alwaysOnTblP3Col: 'Phase 3',
    totalKwh: 'Verbrauch kWh',
    recognitionKwh: 'Erkennung kWh',
    classificationKwh: 'Klassifizierung kWh',
    alwaysOnKwh: 'Always On kWh',
    completeness24h: 'Vollständigkeit der Rohdaten in den letzten 24 Stunden',
    completeness1h: 'Vollständigkeit der Rohdaten in den letzten 60 Minuten',
    recognitionRate: 'Erkennungsrate',
    recognitionCorrectness: 'Korrektheit der Erkennung',
    classificationRate: 'Klassifizierungsrate',
    recognitions: 'Erkennungen',
    recognitionsMobile: 'Live-Stromverbrauch',
    alwaysOnPerDay: 'Always On pro Tag',
    singleGraphYLabel: 'Stromverbrauch / Temperatur',
    singleGraphUsage: 'Stromverbrauch',
    singleGraphTemp: 'Temperatur',
    singleGraphStatus: 'Status',
    addonGraphYLabel: 'PREMIUM DATEN',
    kwhCost: 'Kosten pro Kilowatt',
    wattUnit: 'Watt',
    wUnit: 'W',
    kwUnit: 'Kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'KWh',
    kgUnit: 'Kilogramm',
    costUnit: '€',
    var: 'VAR',
    periodPicker: 'Periode (bis zu 7 Tage)',
    deviceAssistant: 'Geräte Assistent',
    meterShortName: 'Messgerät Kurzname (optional)',
};
